<template>
  <div class="container">
    <div class="flex-box">
      <h1 class="news-complete">완성한 기사</h1>
    </div>
    <div class="news">
      <div class="flex-box">
        <img class="news-complete-img" src="../assets/img/completenews_titlelogo.png" />
      </div>
      <h2 class="news-complete-title paper-title">{{ current_article[0].title }}</h2>
      <h2 class="news-complete-title paper-sub">{{ current_article[0].title_sub }}</h2>
      <div class="flex-box">
        <img
          v-if="current_article_id < 10"
          class="news-paper-img"
          :src="require('../assets/img/article_img/image_article_00'+current_article_id+'.png')"
        />
        <img
          v-else
          class="news-paper-img"
          :src="require('../assets/img/article_img/image_article_0'+current_article_id+'.png')"
        />
      </div>
      <div class="paper-meta">
        <h2>{{ year }}.{{ month }}.{{ day }}</h2>
        <h2>울릉군 울릉읍 독도리에서</h2>
        <h2>{{ user_name }} 기자</h2>
      </div>
      <div class="paper-body">
        <p>{{ current_article[0].prints }}</p>
      </div>
      <div class="paper-footer">
        <div class="flex-box paper-footer-head">
          <h2>댓글</h2>
          <img class="comment-good" src="../assets/img/comment_good.png" />
        </div>
        <div class="flex-box paper-footer-body">
          <img class="comment-profile" src="../assets/img/comment_profile.png" />
          <p class="comment-text">{{ current_article[0].result }}</p>
        </div>
      </div>
    </div>

    <div v-if="$route.params.id == 2" class="paper-desk flex-box">
      <img src="../assets/img/korea_desk.png" />
      <div class="paper-desk-balloon">
        <p>작성한 육하원칙 중 일부가 사실과 달라 데스크에서 수정 후 발행했습니다.</p>
      </div>
    </div>
    <!-- <div class="myhashtag-box">
      <h2>나의 감정 해시태그</h2>
      <div class="myhashtag-content">
        <bar-chart></bar-chart>
      </div>
    </div> -->
    <router-link
      to="/game"
      class="news-complete-white"
      @click.native.prevent="updatedSectionstate"
    >다른 기사 선택하기</router-link>
    <router-link
      to="/game/news"
      class="news-complete-black"
      @click.native.prevent="updatedArticlestate"
    >{{ current_section }} 계속하기</router-link>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      day: "",
      month: "",
      year: "",
    };
  },
  created() {
    var today = new Date();
    this.day = today.getDate();
    this.month = today.getMonth() + 1;
    this.year = today.getFullYear();
  },
  mounted() {
    this.$store.dispatch("loadhashtag", this.current_article_id);
  },
  upadated() {
    this.$store.dispatch("loadTotalpoint");
  },
  computed: {
    ...mapGetters([
      "current_section",
      "current_section_id",
      "current_article",
      "current_article_id",
      "user_name",
    ]),
  },
  methods: {
    updatedArticlestate() {
      this.$store.dispatch("loadArticleState", this.current_section_id);
      this.$store.dispatch("loadSectionState");
    },
    updatedSectionstate() {
      this.$store.dispatch("loadSectionState");
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/newspaper.vue